import styles from './AuditInfoPanel.module.css'

interface QuestionSectionProps {
  question: string
}

function QuestionSection({ question }: QuestionSectionProps) {
  return (
    <div className={styles.questionSection}>
      <h3 className={styles.sectionLabel}>Question</h3>
      <p className={styles.questionText}>{question}</p>
    </div>
  )
}

export default QuestionSection
